import React from 'react';

export const StatusBadge = ({ isActive }: { isActive: boolean }) => {
  const activeStyles = {
    container: "bg-[#ECFDF3] border-[#ABEFC6]",
    dot: "bg-[#17B26A]",
    text: "text-[#067647]"
  };

  const inactiveStyles = {
    container: "bg-[#FEF3F2] border-[#FECDCA]",
    dot: "bg-[#F04438]",
    text: "text-[#B42318]"
  };

  const styles = isActive ? activeStyles : inactiveStyles;

  return (
    <span className={`inline-flex justify-center items-center gap-1 sm:gap-[0.375rem] h-[1.375rem] sm:h-6 md:h-7 pl-2 sm:pl-[0.625rem] pr-2.5 sm:pr-3 py-1 border rounded-2xl ${styles.container}`}>
      <span className={`flex-shrink-0 inline-block size-1 sm:size-1.5 md:size-2 rounded-full ${styles.dot}`}></span>
      <span className={`inline-block text-xs sm:text-[0.825rem] md:text-sm font-medium leading-4 sm:leading-5 ${styles.text}`}>
        {isActive ? "Active" : "Inactive"}
      </span>
    </span>
  );
};
